import React, { useState } from 'react';
import Header from 'on_web/components/shared/Menu/Header/Header';
import StickyNavigation from 'on_web/components/shared/Common/StickyNavigation/StickyNavigation';

import StepProgressIndicator from 'on_web/components/shared/StepProgressIndicator/StepProgressIndicator';
import Question from 'on_web/components/shared/Question/Question';

import { useTranslation } from 'react-i18next';

import UserProfileContext from 'on_web/context/userProfileContext';
import { getLivingArrangementsQuestions } from 'on_web/helpers/questions';

export default function EnvironmentStep1(props) {
  const context = React.useContext(UserProfileContext);
  const [metadata, setMetaData] = useState(
    context &&
      context.user_metadata &&
      context.user_metadata.livingArrangements &&
      context.user_metadata.livingArrangements.other
      ? context.user_metadata.livingArrangements.other
      : ''
  );
  const [, setNextButtonDisabled] = useState(true);
  const [selectedItems, setSelectedItems] = useState(
    context &&
      context.user_metadata &&
      context.user_metadata.livingArrangements &&
      context.user_metadata.livingArrangements.selectedItems
      ? context.user_metadata.livingArrangements.selectedItems
      : []
  );
  const { t } = useTranslation();

  const onClickNext = () => {
    const userMetadata = context ? context.user_metadata : null;
    if (props.onClickNext && userMetadata) {
      userMetadata.livingArrangements = {};
      userMetadata.livingArrangements.selectedItems = selectedItems;
      userMetadata.livingArrangements.other = metadata;

      props.onClickNext(userMetadata);
    }
  };

  const onClickBack = () => {
    if (props.onClickBack) {
      props.onClickBack();
    }
  };

  const questions = getLivingArrangementsQuestions(selectedItems, t);

  const onCheckboxChange = (value, checked) => {
    if (checked) {
      if (value === '1') {
        setSelectedItems([
          ...selectedItems.filter(i => i !== '2' && i !== '3'),
          '1',
        ]);
      } else if (value === '2' || value === '3') {
        setSelectedItems([...selectedItems.filter(i => i !== '1'), value]);
      } else {
        setSelectedItems([...selectedItems, value]);
      }
    } else {
      setSelectedItems(selectedItems.filter(i => i !== value));
    }

    if (value === '6' && checked === false) {
      setMetaData('');
    }
  };

  const onAnswerMetadata = metadata => {
    setMetaData(metadata);
    if (metadata === '') {
      setNextButtonDisabled(true);
    } else {
      setNextButtonDisabled(false);
    }
  };

  return (
    <div>
      <Header />
      {(context == null || context.editMode !== true) && (
        <StepProgressIndicator
          showBasicQuestions={context.showBasicQuestions}
          selectedSlideIx={
            process.env.REACT_APP_HIDE_DNA_SECTION !== 'true' ? 4 : 3
          }
          firstStep
        />
      )}

      <Question
        sectionTitle={t(
          'onboarding.environmentSection.environmentStep1.sectionTitle'
        )}
        checkboxSelection={{
          items: questions,
          twoColumns: false,
          showMetaDataInputFor: '6',
        }}
        onAnswer={(val, checked) => onCheckboxChange(val, checked)}
        onAnswerMetadata={metadata => onAnswerMetadata(metadata)}
        metadataValue={metadata}
        deselectAllValue={'1'}
        disableAllValue={'1'}
        additionalDisableAndDeselectValues={['2', '3']}
        excludeFromDeselectValues={['4', '5']}
        dividerBelowItem={3}
        placeholder={'Text'}
      />

      <StickyNavigation
        onClickNext={() => onClickNext()}
        onClickBack={() => onClickBack()}
        nextButtonDisabled={
          selectedItems.length === 0 ||
          (selectedItems.length === 1 && selectedItems[0] === '6')
        }
        editMode={context && context.editMode}
      />
    </div>
  );
}
